
export const CommingSoon = () => {
    return (
        <section className="py-3">
            <div className="container">
                <div className="row pt-5">
                    <div className="col-12 mb-5">
                        <center>
                            <div className="thankyou-text mt-3">
                                <h2 className="main-heading h4">We're Coming Soon</h2>
                                <p>We're working hard to give you the best experience!</p>

                            </div>
                        </center>
                    </div>
                </div>
            </div>
        </section>
    )
}